import { Components, Theme } from '@mui/material/styles';

export const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: (theme) => {
    return {
      // This is to make the frame a bit darker than the content background
      body: {
        backgroundColor: theme?.vars?.palette.background.body,
      },
    };
  },
};
